export default function ({ app, redirect }) {
  if (process.env.MAINTENANCE_MODE === 'true') {
    return redirect(302, {  path: app.localePath('maintenance') })
  }
}
